import React from 'react';
import { Row } from 'reactstrap';
import {
  Checkbox, FormControlLabel, FormGroup, Select, MenuItem, ListItemText, OutlinedInput,
} from '@material-ui/core';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SELECT_VALUES = {
  status: ['REJECTED', 'PENDING', 'ACCEPTED'],
  fontsUploaded: ['yes', 'no', 'deprecated'],
  isGif: ['yes', 'no'],
  isPremium: ['yes', 'no'],
  internalNote: ['yes', 'no'],
  sortBy: ['rank', 'name', 'date'],
};
const SELECT_VALUES_DEFAULT = {
  status: ['ACCEPTED'],
  fontsUploaded: ['yes', 'no', 'deprecated'],
  isGif: ['yes', 'no'],
  isPremium: ['yes', 'no'],
  internalNote: ['yes', 'no'],
  sortBy: ['rank'],
};

const Filters = ({ filters, setFilters }) => {
  const handleSelectChange = (name, event) => {
    const {
      target: { value },
    } = event;
    const newValue = typeof value === 'string' ? value.split(',') : value;
    const filtersTmp = { ...filters };
    if (name !== 'sortBy') {
      filtersTmp[name] = newValue;
      selectValues[name].set(newValue);
      setFilters(filtersTmp);
    } else {
      // Only one field sort
      const oldValue = selectValues[name].value;
      const newSortValue = newValue.filter((v) => v !== oldValue[0]);
      filtersTmp[name] = newSortValue;
      selectValues[name].set(newSortValue);
      setFilters(filtersTmp);
    }
  };
  const selectValues = {};
  Object.keys(SELECT_VALUES).forEach((key) => {
    selectValues[key] = {};
  });
  Object.keys(SELECT_VALUES).forEach((key) => {
    const [stateValue, stateSetter] = React.useState(SELECT_VALUES_DEFAULT[key]);
    selectValues[key].value = stateValue;
    selectValues[key].set = stateSetter;
  });

  return (
    <Row>
      <FormGroup style={{ flexDirection: 'row' }}>
        {Object.keys(SELECT_VALUES).map((key) => (
          <FormControlLabel
            control={(
              <Select
                multiple
                onChange={(e) => handleSelectChange(key, e)}
                input={<OutlinedInput label="Tag" />}
                value={selectValues[key].value}
                renderValue={(selected) => `${key}: ${selected.join(', ')}`}
                MenuProps={MenuProps}
              >
                {SELECT_VALUES[key].map((value) => (
                  <MenuItem value={value}>
                    <Checkbox checked={selectValues[key].value.indexOf(value) > -1} />
                    <ListItemText primary={value} />
                  </MenuItem>
                ))}
              </Select>
           )}
          />
        ))}
      </FormGroup>
    </Row>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/templates-manager/filters.js